import i18n from '@/VueI18n'
import { format } from 'date-fns'
import { FireRiskEnum } from '@/@core/fire-risk-dashboard/domain/enum/FireRisk.enum'
import { FireOutbreakOccurrenceEnum } from '@/@core/fire-risk-dashboard/domain/enum/FireOutbreakOccurence.enum'
import { FireOutbreakReactionEnum } from '@/@core/fire-risk-dashboard/domain/enum/FireOutbreakReaction.enum'

// Os labels das entities do @core ficam em pt-BR (o domínio não conhece o i18n);
// tudo que é exibido ao usuário passa por aqui.
export class FireRiskDashboardLabelProvider {
	private static readonly RISK_KEYS: Record<FireRiskEnum, string> = {
		[FireRiskEnum.NONE]: 'fireRiskDashboardRiskNone',
		[FireRiskEnum.NULL]: 'fireRiskDashboardRiskNull',
		[FireRiskEnum.SMALL]: 'fireRiskDashboardRiskSmall',
		[FireRiskEnum.MEDIUM]: 'fireRiskDashboardRiskMedium',
		[FireRiskEnum.HIGH]: 'fireRiskDashboardRiskHigh',
		[FireRiskEnum.HIGHEST]: 'fireRiskDashboardRiskHighest',
	}

	private static readonly OCCURRENCE_KEYS: Record<FireOutbreakOccurrenceEnum, string> = {
		[FireOutbreakOccurrenceEnum.FARM]: 'fireRiskDashboardOccurrenceFarm',
		[FireOutbreakOccurrenceEnum.BUFFER]: 'fireRiskDashboardOccurrenceBuffer',
	}

	private static readonly REACTION_KEYS: Record<FireOutbreakReactionEnum, string> = {
		[FireOutbreakReactionEnum.POSITIVE]: 'fireRiskDashboardReactionPositive',
		[FireOutbreakReactionEnum.NEGATIVE]: 'fireRiskDashboardReactionNegative',
		[FireOutbreakReactionEnum.IMPOSSIBLE]: 'fireRiskDashboardReactionUndetermined',
	}

	static risk(risk: FireRiskEnum): string {
		return i18n.t(this.RISK_KEYS[risk]) as string
	}

	static occurrence(occurrence: FireOutbreakOccurrenceEnum): string {
		return i18n.t(this.OCCURRENCE_KEYS[occurrence]) as string
	}

	static reaction(reaction?: FireOutbreakReactionEnum): string {
		if (!reaction) return i18n.t('fireRiskDashboardReactionNotEvaluated') as string
		return i18n.t(this.REACTION_KEYS[reaction]) as string
	}

	static dateAtTime(date: Date): string {
		return i18n.t('fireRiskDashboardDateAtTime', {
			date: format(date, 'dd/MM/yyyy'),
			time: format(date, 'HH:mm:ss'),
		}) as string
	}
}
